import { Button, Card, Col, Row, Space, Typography } from 'antd';
import { DownloadOutlined, PlayCircleOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const HeroSection = () => (
  <section id="hero" className="hero-section">
    <Row gutter={[32, 32]} align="middle">
      <Col xs={24} lg={12}>
        <Title level={1} className="hero-title">
          Marcos Cortorreal
        </Title>
        <Title level={3} className="hero-subtitle">
          Full Stack Software Engineer
        </Title>
        <Paragraph className="hero-copy">
          I build React applications and scalable systems. Currently
          working on a couple of creative products such as DJ Depot and a MLB Player Analytics tool.
        </Paragraph>
        <Space size="middle" wrap className="hero-actions">
          <Button
            type="primary"
            size="large"
            icon={<PlayCircleOutlined />}
            href="#video"
          >
            Watch Introduction
          </Button>
          <Button size="large" icon={<DownloadOutlined />} href="/resume.pdf">
            Download Resume
          </Button>
        </Space>
      </Col>
      <Col xs={24} lg={12}>
        <Card className="highlight-card" variant="borderless">
          <Title level={4}>Highlights</Title>
          <ul className="highlight-list">
            <li>8+ years software engineering experience</li>
            <li>Shipped performant React apps at scale</li>
            <li>Memorized 87% of the choreography to the chorus of "It's
              Gonna Be Me" by *NSYNC
            </li>
            <li>Built resilient cloud applications on Kubernetes</li>
            <li>Passionate about social causes and an active community volunteer</li>
          </ul>
        </Card>
      </Col>
    </Row>
  </section>
);

export default HeroSection;
